// Opções de tipo de organização — espelham o cadastro de projeto
// (Forms/First). Usadas no CRUD admin da empresa participante.
export const organizationTypeOptions = [
  {
    value: "Pessoa física",
    label: "Pessoa física",
  },
  {
    value: "Pessoa Jurídica Com Fins Lucrativos",
    label: "Pessoa Jurídica Com Fins Lucrativos",
  },
  {
    value: "Pessoa Jurídica Sem Fins Lucrativos",
    label: "Pessoa Jurídica Sem Fins Lucrativos",
  },
  {
    value: "Organização Não Governamental (ONG)",
    label: "Organização Não Governamental (ONG)",
  },
  {
    value: "Organização da Sociedade Civil de Interesse Público (OSCIP)",
    label: "Organização da Sociedade Civil de Interesse Público (OSCIP)",
  },
  {
    value: "Outro",
    label: "Outro",
  },
];
